<form [formGroup]="formGroup" (ngSubmit)="submit()" class="push">
    <div class="form-group row">
        <label class="col-12" for="email">Place</label>
        <div class="col-md-12">
            <input
                type="text"
                class="form-control"
                id="destination"
                name="destination"
                placeholder="Destination"
                formControlName="googlePlaceString"
                autocomplete="off"
                ngx-google-places-autocomplete
                [options]="options"
                (onAddressChange)="handleAddressChangeOfCity($event)"
                (keyup)="onKeyUp($event)"
            />
            <small
                class="text-danger"
                *ngIf="
                    formGroup.get('googlePlaceString').touched &&
                    formGroup.get('googlePlaceString').value &&
                    !googlePlace
                "
            >
                Please select a valid place from the suggestions.
            </small>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <button type="submit" class="btn btn-alt-success">
                Submit
            </button>
        </div>
    </div>
</form>
